// extracted by mini-css-extract-plugin
module.exports = {"descriptionlineheight":"20px"};